export const NAVIGATION_SET_MODAL = '@navigation/set-modal';
export const NAVIGATION_SET_RACES_TAB = '@navigation/set-races-tab';
export const NAVIGATION_SET_SNACKBAR = '@navigation/set-snackbar';
export const NAVIGATION_SET_POPOUT = '@navigation/set-popout';
export const NAVIGATION_CLEAR_HISTORY = '@navigation/clear-history';
export const NAVIGATION_SET_HISTORY_PUSH = '@navigation/set-history-push';
export const NAVIGATION_SET_HISTORY_POP = '@navigation/set-history-pop';
